/**
 * Owner: Haselton Baker Risk Group, LLC
 * Product: SP3 - SP3-Risk-Model-U
 * Date: 2/4/22
 * Copyright All Rights Reserved
 */
// @flow
import type { Element } from 'react';

import React from 'react';
import {
  CONCRETE_SHEAR_WALLS_LOAD_BEARING,
  MASONRY_SHEAR_WALLS_LOAD_BEARING,
  PERCENT_GLAZING,
  PERCENT_OF_PARTITIONS_ARE_FIRE_BRAKE,
} from '@hbrisk/sp3-risk-model-support/models/app/attributes/names/index.js';
import { Field, FormGroup } from '#components/pages/Models/Model/support/form/index.js';
import ComponentQuestion from './ComponentQuestion/index.js';

type ComponentQuestionsProps = {|
  fieldsByName: Object,
  getSubGroups: Function,
  getQuestions: Function,
  form: string,
|};

const ComponentQuestions = (props: ComponentQuestionsProps): Element<'div'> => {
  const { fieldsByName, form, getSubGroups, getQuestions } = props;

  const renderComponentQuestionGroup = componentGroup => {
    const subGroups = getSubGroups(componentGroup);
    const componentQuestionsBySubGroup = subGroups.map(subGroup => {
      const questionsForSubGroup = getQuestions(componentGroup, subGroup);
      return questionsForSubGroup.length ? (
        <fieldset key={`${componentGroup}-${subGroup}`}>
          <legend>{componentGroup === 'structural' ? `Structural - ${subGroup}` : subGroup}</legend>
          {componentGroup === 'structural' && subGroup === 'Masonry' && (
            <FormGroup form={form} fields={[MASONRY_SHEAR_WALLS_LOAD_BEARING]}>
              <Field field={fieldsByName[MASONRY_SHEAR_WALLS_LOAD_BEARING]} />
            </FormGroup>
          )}
          {componentGroup === 'structural' && subGroup === 'Concrete' && (
            <FormGroup form={form} fields={[CONCRETE_SHEAR_WALLS_LOAD_BEARING]}>
              <Field field={fieldsByName[CONCRETE_SHEAR_WALLS_LOAD_BEARING]} />
            </FormGroup>
          )}
          {componentGroup === 'nonStructural' && subGroup === 'Exterior' && (
            <FormGroup form={form} fields={[PERCENT_GLAZING]}>
              <Field field={fieldsByName[PERCENT_GLAZING]} />
            </FormGroup>
          )}
          {componentGroup === 'nonStructural' && subGroup === 'Interior Finishes' && (
            <FormGroup form={form} fields={[PERCENT_OF_PARTITIONS_ARE_FIRE_BRAKE]}>
              <Field field={fieldsByName[PERCENT_OF_PARTITIONS_ARE_FIRE_BRAKE]} />
            </FormGroup>
          )}
          {questionsForSubGroup.map(question => (
            <ComponentQuestion
              key={`${componentGroup}-${question.name}`}
              fieldsByName={fieldsByName}
              form={form}
              name={question.name}
            />
          ))}
        </fieldset>
      ) : null;
    });
    return componentQuestionsBySubGroup;
  };

  return (
    <div>
      {renderComponentQuestionGroup('structural')}
      {renderComponentQuestionGroup('nonStructural')}
    </div>
  );
};

export default ComponentQuestions;
